import React from 'react';
import { Card, CardContent, Typography, Paper, Stack, Button, Box } from '@mui/material';
import { FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ClubEventsCalendar from '../cms/ClubEventsCalendar';

const Etkinlikler = () => {
  const navigate = useNavigate();

  return (
    <Card sx={{ flex: '0 0 calc(100% - 16px)', minWidth: 300, border: '1px solid #f1f1f1', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)', borderRadius: '8px' }}>
      <CardContent sx={{ p: 2.5 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                backgroundColor: '#f5f5f5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <FaCalendarAlt style={{ fontSize: '18px', color: '#0E4D94' }} />
            </Box>
            <Typography sx={{ fontSize: '18px', fontWeight: 500, color: '#444444' }}>
              Etkinlikler
            </Typography>
          </Stack>
          <Button
            variant="text"
            size="small"
            onClick={() => navigate('/events')}
            sx={{
              textTransform: 'none',
              fontSize: '13px',
              fontWeight: 500,
              backgroundColor: 'transparent',
              color: '#0E4D94',
              textDecoration: 'underline',
              '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline',
              },
            }}
          >
            Tüm Etkinlikler
          </Button>
        </Stack>
        <Paper sx={{ p: 1, boxShadow: 'none', mt: 5 }}>
          <ClubEventsCalendar />
        </Paper>
      </CardContent>
    </Card>
  );
};

export default Etkinlikler;
